import { authClient } from '@/shared/lib/betterAuth/auth-client'
import {
  AUTH_TOKEN_KEY,
  USER_PROFILE_KEY,
  AUTH_HEADER_SCHEME,
} from '@/shared/constants/auth'
import {
  SESSION_QUERY_KEY,
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  SESSION_NETWORK_MODE,
} from '@/shared/constants/cache'
import { refreshAccessToken } from '@/shared/lib/betterAuth/refresh-token'
import { getSecureItem } from '@/shared/lib/storage'

async function fetchSession(token: string) {
  const { data } = await authClient.getSession({
    fetchOptions: {
      headers: { Authorization: `${AUTH_HEADER_SCHEME} ${token}` },
    },
  })
  return data
}

export const sessionQueryOptions = {
  queryKey: SESSION_QUERY_KEY,
  queryFn: async () => {
    const token = await getSecureItem(AUTH_TOKEN_KEY)
    if (!token) throw new Error('No auth token')

    try {
      const session = await fetchSession(token)
      if (session) return session

      const newToken = await refreshAccessToken()
      if (newToken !== '') {
        const refreshedSession = await fetchSession(newToken)
        if (refreshedSession) return refreshedSession
      }

      const cached = await getSecureItem(USER_PROFILE_KEY)
      if (cached) return { user: JSON.parse(cached), session: undefined }
      throw new Error('Session unavailable and no cached profile')
    } catch {
      const cached = await getSecureItem(USER_PROFILE_KEY)
      if (cached) return { user: JSON.parse(cached), session: undefined }
      throw new Error('Network error and no cached profile')
    }
  },
  staleTime: CACHE_STALE_TIME,
  gcTime: CACHE_GC_TIME,
  networkMode: SESSION_NETWORK_MODE,
}
